import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useDiasDaGrade, AvisoDiasDaGrade } from '../../components/GradeHoraria'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { FiAlertTriangle } from 'react-icons/fi'
import {
    indexRecordClassTaughtByTeacherType,
    clssInfo,
    updateRecordClassTaught,
    DestroyClass,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getSchoolDays,
} from '../../Api'
import { useNavigate, useLocation } from 'react-router-dom'
import { SlActionUndo } from 'react-icons/sl'
import {
    Container,
    ContainerDivs,
    Header,
    HeaderInfo,
    Title,
    Subtitle,
    HeaderBack,
    StudentSection,
    Table,
    SectionTitle,
    CountBadge,
    Register,
    SearchBar,
    ClearSearch,
    ButtonReg,
    ContainerTable,
    Span,
    TableRow,
    DateCell,
    WarnTag,
    DescriptionCell,
    CardActions,
    Button,
    ButtonEdit,
    ActionGhost,
    ActionDanger,
    ShowMoreButton,
    InfoText,
    EditContainer,
    ContainerDelet,
    ErrorMessage,
    SkeletonCard,
    SkeletonLine,
    HiddenOnPrint,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold
} from './style'

// ── helpers fora do componente ─────────────────────────────────────
const extractId = (v) => {
    if (!v) return null
    if (typeof v === 'string') {
        const t = v.trim()
        if ((t.startsWith('"') && t.endsWith('"')) ||
            (t.startsWith('[') && t.endsWith(']')) ||
            (t.startsWith('{') && t.endsWith('}'))) {
            try { v = JSON.parse(t) } catch { /* mantém */ }
        }
    }
    if (Array.isArray(v)) v = v[0]
    if (v && typeof v === 'object') v = v._id ?? v.id ?? null
    const s = String(v ?? '').trim()
    return /^[a-fA-F0-9]{24}$/.test(s) ? s : null
}

const safeParse = (raw) => {
    try { return raw ? JSON.parse(raw) : null } catch { return null }
}

const pad2 = (n) => String(n).padStart(2, '0')

// 'dd/mm/aaaa' → 'segunda-feira'
const DIAS_SEMANA = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
const diaDaSemana = (ddmmaaaa) => {
    const [d, m, y] = String(ddmmaaaa || '').split('/').map(Number)
    const dt = new Date(y, (m || 1) - 1, d || 1)
    return isNaN(dt.getTime()) ? '' : DIAS_SEMANA[dt.getDay()]
}

const QUILL_MODULES = {
    toolbar: [
        [{ font: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }, { background: [] }],
        ['clean']
    ]
}

const COLLAPSED_LIMIT = 3

const Grade = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { employee } = location.state || {}

    const [loading, setLoading] = useState(true)
    const [, setIsTeacher] = useState(null)
    const [$Class, set$Class] = useState(null)
    const [, setId_employee] = useState('')
    const [yearclss, setyearclss] = useState('')
    const [recordClassTaught, setRecordClassTaught] = useState([])
    const [expandedRows, setExpandedRows] = useState([])
    const [editingIndex, setEditingIndex] = useState(null)
    const [editingId, setEditingId] = useState('')
    const [editedDescription, setEditedDescription] = useState('')

    const [RemoveClass, setRemoveClass] = useState(null)
    const [RemoveDayClass, setDayClass] = useState('')
    const [RemoveMonthClass, setMonthClass] = useState('')
    const [RemoveYearClass, setYearClass] = useState('')
    const [IdClass, setIdClass] = useState('')
    const [day, setDay] = useState('')
    const [month, setMonth] = useState('')

    const [id_teacher, setId_teacher] = useState('')
    // grade horária: só os dias em que o professor tem aula (+ sábados letivos)
    const grade = useDiasDaGrade(sessionStorage.getItem('class-info'), extractId(id_teacher) || id_teacher)
    const [physicalEducation, setPhysicalEducationTeacher] = useState(null)

    const [errorMessage, setErrorMessage] = useState('')
    const [savingEdit, setSavingEdit] = useState(false)
    const [printing, setPrinting] = useState(false)
    const [showAllClasses, setShowAllClasses] = useState(false)
    const [schoolDays, setSchoolDays] = useState([])
    const [searchDate, setSearchDate] = useState('')

    // ── carga inicial (depende do professor escolhido pelo supervisor) ─
    useEffect(() => {
        let cancelled = false
        ;(async () => {
            setLoading(true)

            const id_class = sessionStorage.getItem('class-info')
            const physicalRaw = sessionStorage.getItem('physicalEducationTeacher')
            const idSchool = safeParse(sessionStorage.getItem('id-school'))

            const selectedId = extractId(employee)
            const physicalId = extractId(safeParse(physicalRaw))
            const teacherType = (physicalId && selectedId === physicalId) ? 'ED_FISICA' : 'REGENTE'

            try {
                const resClass = await clssInfo(id_class)
                if (cancelled) return
                set$Class(resClass)

                const $yearClass = resClass.data.data.find(c => c.year)
                setyearclss($yearClass)

                // dias letivos e aulas registradas EM PARALELO
                const [schoolDaysRes, res] = await Promise.all([
                    getSchoolDays(idSchool, $yearClass.year),
                    indexRecordClassTaughtByTeacherType($yearClass.year, id_class, teacherType)
                ])
                if (cancelled) return

                if (schoolDaysRes?.data) setSchoolDays(schoolDaysRes.data.schoolDays)
                setRecordClassTaught(res?.data?.data || [])
                setId_teacher(employee)
                setPhysicalEducationTeacher(physicalRaw)
                setId_employee(employee)

                const isTeacher = resClass.data.data.find(r => r)?.id_employee.find(r => r)?._id
                setExpandedRows([])
                setIsTeacher(isTeacher)
            } catch (err) {
                console.error('Erro ao carregar aulas:', err)
            } finally {
                if (!cancelled) setLoading(false)
            }
        })()
        return () => { cancelled = true }
    }, [employee])

    // ── modo impressão ──────────────────────────────────────────────
    useEffect(() => {
        const onBefore = () => setPrinting(true)
        const onAfter = () => setPrinting(false)
        window.addEventListener('beforeprint', onBefore)
        window.addEventListener('afterprint', onAfter)
        return () => {
            window.removeEventListener('beforeprint', onBefore)
            window.removeEventListener('afterprint', onAfter)
        }
    }, [])

    // ── aulas ordenadas (memoizado) ─────────────────────────────────
    // busca por data (aula lecionada ou dia letivo sem aula)
    const searchFormatted = useMemo(() => {
        if (!searchDate) return null
        const [y, m, d] = searchDate.split('-')
        return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`
    }, [searchDate])

    const filteredDone = useMemo(() => {
        if (!searchFormatted) return recordClassTaught
        return recordClassTaught.filter(i => `${pad2(i.day)}/${pad2(i.month)}/${i.year}` === searchFormatted)
    }, [recordClassTaught, searchFormatted])

    const sortedDone = useMemo(() => {
        return [...filteredDone].sort((a, b) =>
            new Date(b.year, b.month - 1, b.day) - new Date(a.year, a.month - 1, a.day))
    }, [filteredDone])

    // imprimindo → mostra todas; caso contrário, fatia em COLLAPSED_LIMIT
    const visibleDone = (showAllClasses || printing)
        ? sortedDone
        : sortedDone.slice(0, COLLAPSED_LIMIT)
    const hasMore = sortedDone.length > COLLAPSED_LIMIT

    // ── dias letivos sem aula registrada (memoizado) ────────────────
    const uniqueClassDates = useMemo(() => {
        const dates = recordClassTaught.map(i => `${pad2(i.day)}/${pad2(i.month)}/${i.year}`)
        return new Set(dates)
    }, [recordClassTaught])

    const daysWithoutClasses = useMemo(() => {
        const formatted = schoolDays.map(d => {
            const [y, m, dd] = d.split('-')
            return `${dd.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`
        })
        return formatted.filter(day => !uniqueClassDates.has(day) && grade.permitido(day))
    }, [schoolDays, uniqueClassDates, grade])

    const filteredPending = useMemo(() => {
        if (!searchFormatted) return daysWithoutClasses
        return daysWithoutClasses.filter(d => d === searchFormatted)
    }, [daysWithoutClasses, searchFormatted])

    // dias letivos (dd/mm/aaaa) — para marcar aulas registradas fora deles
    const schoolDaysSet = useMemo(() => new Set(schoolDays.map(d => {
        const [y, m, dd] = d.split('-')
        return `${dd.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`
    })), [schoolDays])
    const isNaoLetivo = useCallback(
        (aula) => schoolDaysSet.size > 0 && !schoolDaysSet.has(`${pad2(aula.day)}/${pad2(aula.month)}/${aula.year}`),
        [schoolDaysSet]
    )

    // ── verifica se o período (bimestre) da aula está ABERTO ────────
    // Reutilizado por editar e apagar.
    const isClassPeriodOpen = useCallback(async (res) => {
        const idSchool = safeParse(sessionStorage.getItem('id-school'))
        const dateSelected = new Date(yearclss.year, res.month - 1, res.day)

        const [IstQuarter, IIndQuarter, IIIrdQuarter, IVthQuarter] = await Promise.all([
            getIstQuarter(yearclss.year, idSchool),
            getIIndQuarter(yearclss.year, idSchool),
            getIIIrdQuarter(yearclss.year, idSchool),
            getIVthQuarter(yearclss.year, idSchool)
        ])

        const getQuarterStatus = (quarterData) =>
            quarterData.data.data.map((r) => {
                const startDate = new Date(+yearclss.year, +r.startmonth - 1, +r.startday)
                const endDate = new Date(+yearclss.year, +r.endmonth - 1, +r.endday)
                return (dateSelected >= startDate && dateSelected <= endDate) ? r.bimonthly : null
            }).find(r => r)

        const result = {
            IstQuarter: getQuarterStatus(IstQuarter) || null,
            IIndQuarter: getQuarterStatus(IIndQuarter) || null,
            IIIrdQuarter: getQuarterStatus(IIIrdQuarter) || null,
            IVthQuarter: getQuarterStatus(IVthQuarter) || null
        }

        const turma = $Class.data.data[0]
        const myId = extractId(id_teacher)
        const physicalId = extractId(physicalEducation)
        const isPhysical = !!physicalId && myId === physicalId

        const statusFor = (label) => isPhysical
            ? turma.dailyStatus[label].physicalEducationTeacher
            : turma.dailyStatus[label].regentTeacher

        let statusAtual = null
        if (result.IstQuarter) statusAtual = statusFor('1º BIMESTRE')
        if (result.IIndQuarter) statusAtual = statusFor('2º BIMESTRE')
        if (result.IIIrdQuarter) statusAtual = statusFor('3º BIMESTRE')
        if (result.IVthQuarter) statusAtual = statusFor('4º BIMESTRE')

        return statusAtual === 'aberto'
    }, [yearclss, $Class, id_teacher, physicalEducation])

    const toggleRowExpansion = useCallback((index) => {
        if (printing) return
        setExpandedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index])
    }, [printing])

    const getDescriptionPreview = useCallback((description) => {
        const maxLength = 100
        const d = description || ''
        return d.length > maxLength ? `${d.slice(0, maxLength)}...` : d
    }, [])

    const handleEdit = useCallback(async (index, res) => {
        setDay(`${res.day}`)
        setMonth(`${res.month}`)
        try {
            const aberto = await isClassPeriodOpen(res)
            if (aberto) {
                setEditingIndex(index)
                setEditingId(res._id)
                setEditedDescription(res.description)
            } else {
                alert('Edição não permitida. Para editar a aula, contate o Diretor ou Supervisor.')
            }
        } catch (error) {
            console.error('Erro ao verificar bimestre:', error)
            alert('Erro ao verificar bimestre. Tente novamente.')
        }
    }, [isClassPeriodOpen])

    const handleSaveEdit = useCallback(async () => {
        if (savingEdit) return
        setSavingEdit(true)
        try {
            const res = await updateRecordClassTaught(editedDescription, day, month, editingId)
            if (res.data) {
                setRecordClassTaught(prev => prev.map(item =>
                    item._id === editingId
                        ? { ...item, description: editedDescription, day, month }
                        : item))
                setEditingIndex(null)
                setErrorMessage('')
            } else {
                setErrorMessage('Erro ao cadastrar. Verifique os dados e tente novamente.')
            }
        } catch (error) {
            console.error('Erro ao atualizar aula:', error)
            setErrorMessage('Ocorreu um erro ao salvar a edição. Tente novamente.')
        } finally {
            setSavingEdit(false)
        }
    }, [savingEdit, editedDescription, day, month, editingId])

    // bloqueia exclusão se o período estiver fechado
    const handleDestroy = useCallback(async (res) => {
        try {
            const aberto = await isClassPeriodOpen(res)
            if (!aberto) {
                alert('Exclusão não permitida. Para apagar a aula, contate o Diretor ou Supervisor.')
                return
            }
        } catch (error) {
            console.error('Erro ao verificar bimestre:', error)
            alert('Erro ao verificar bimestre. Tente novamente.')
            return
        }
        setRemoveClass(res)
        setDayClass(res.day)
        setMonthClass(res.month)
        setYearClass(res.year)
        setIdClass(res._id)
    }, [isClassPeriodOpen])

    const Destroy = useCallback(async () => {
        try {
            const res = await DestroyClass(IdClass)
            if (res) {
                setRecordClassTaught(prev => prev.filter(r => r._id !== IdClass))
                setRemoveClass(null)
                setIdClass(''); setDayClass(''); setMonthClass(''); setYearClass('')
            }
        } catch (err) {
            console.error('Erro ao apagar aula:', err)
        }
    }, [IdClass])

    const goBack = useCallback(() => navigate(-1), [navigate])

    // registrar aula a partir de um dia pendente (mantém o employee no state)
    const registrarAula = useCallback((dateStr) => {
        if (dateStr) {
            const [d, m, y] = dateStr.split('/')
            sessionStorage.setItem('day', JSON.stringify(Number(d)))
            sessionStorage.setItem('month', JSON.stringify(Number(m)))
            sessionStorage.setItem('year', JSON.stringify(Number(y)))
        }
        navigate('/Supervisor-record-class-taught', { state: { employee } })
    }, [navigate, employee])

    // ── skeleton ────────────────────────────────────────────────────
    if (loading) {
        return (
            <Container>
                <ContainerDivs>
                    <Header>
                        <HeaderInfo><Title>Aulas Lecionadas</Title></HeaderInfo>
                    </Header>
                    {[1, 2, 3].map(i => (
                        <SkeletonCard key={i}>
                            <SkeletonLine $w="30%" $h="16px" />
                            <SkeletonLine $w="100%" />
                            <SkeletonLine $w="80%" />
                        </SkeletonCard>
                    ))}
                </ContainerDivs>
            </Container>
        )
    }

    // ── confirmação de exclusão ─────────────────────────────────────
    if (RemoveClass) {
        return (
            <Container>
                <ContainerDivs>
                    <ContainerDelet>
                        <h2>Apagar aula</h2>
                        <h4>
                            Tem certeza que deseja apagar a aula do dia{' '}
                            <strong>{RemoveDayClass}/{RemoveMonthClass}/{RemoveYearClass}</strong>?
                        </h4>
                        <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', justifyContent: 'center' }}>
                            <ActionGhost onClick={() => setRemoveClass(null)}>Cancelar</ActionGhost>
                            <ActionDanger onClick={Destroy}>Apagar</ActionDanger>
                        </div>
                    </ContainerDelet>
                </ContainerDivs>
            </Container>
        )
    }

    return (
        <Container>
            <ContainerDivs>
                <Header>
                    <HeaderInfo>
                        <Title>Aulas Lecionadas</Title>
                        {yearclss?.name && <Subtitle>{yearclss.name}</Subtitle>}
                    </HeaderInfo>
                    <HeaderBack onClick={goBack} aria-label="Voltar">
                        <SlActionUndo fontSize="20px" />
                    </HeaderBack>
                </Header>

                <StudentSection>
                    <Register>
                        {/* busca por data: aula lecionada ou dia letivo sem aula */}
                        <SearchBar>
                            <label htmlFor="busca-aula">Buscar aula ou dia sem aula</label>
                            <input
                                id="busca-aula"
                                type="date"
                                value={searchDate}
                                onChange={(e) => setSearchDate(e.target.value)}
                            />
                            {searchDate && (
                                <ClearSearch onClick={() => setSearchDate('')}>Limpar</ClearSearch>
                            )}
                        </SearchBar>
                        <ButtonReg
                            onClick={() => navigate('/Supervisor-record-class-taught', { state: { employee } })}
                            className={HiddenOnPrint}
                        >
                            + Registrar Nova Aula
                        </ButtonReg>
                    </Register>

                    <Table>
                        <SectionTitle>
                            <h3>✅ Aulas lecionadas</h3>
                            <CountBadge>{filteredDone.length} registradas</CountBadge>
                        </SectionTitle>

                        {sortedDone.length === 0 ? (
                            <InfoText>Não há nenhum registro.</InfoText>
                        ) : (
                            <>
                            {visibleDone.map((res, index) => {
                                const isExpanded = expandedRows.includes(index)
                                const naoLetivo = isNaoLetivo(res)
                                return (
                                    <React.Fragment key={res._id || index}>
                                        <ContainerTable $warn={naoLetivo}>
                                            {naoLetivo && (
                                                <WarnTag title="Aula registrada em um dia que não está cadastrado como dia letivo. Verifique a data.">
                                                    <FiAlertTriangle size={18} /> Verificar se foi dia letivo
                                                </WarnTag>
                                            )}
                                            <Span>
                                                <div>Professor: <p>{res.id_teacher?.name}</p></div>
                                                {res.id_class?.serie &&
                                                    <div>Série: <p>{res.id_class.serie}</p></div>}
                                                <div>Turma: <p>{res.id_class?.name}</p></div>
                                            </Span>

                                            <TableRow>
                                                <DateCell>📅 {res.day}/{res.month}/{res.year}</DateCell>
                                                <DescriptionCell>
                                                    <div className={`description ${isExpanded ? 'expanded' : 'collapsed'}`}>
                                                        <div
                                                            style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}
                                                            dangerouslySetInnerHTML={{
                                                                __html: isExpanded || printing
                                                                    ? res.description
                                                                    : getDescriptionPreview(res.description)
                                                            }}
                                                        />
                                                    </div>
                                                </DescriptionCell>
                                            </TableRow>

                                            <CardActions>
                                                {!printing && (
                                                    <ActionGhost onClick={() => toggleRowExpansion(index)}>
                                                        {isExpanded ? 'Ver menos' : 'Ver mais'}
                                                    </ActionGhost>
                                                )}
                                                {isExpanded && (
                                                    <Button onClick={() => handleEdit(index, res)}>
                                                        Editar
                                                    </Button>
                                                )}
                                                {isExpanded && (
                                                    <ActionDanger onClick={() => handleDestroy(res)}>
                                                        Apagar
                                                    </ActionDanger>
                                                )}
                                            </CardActions>
                                        </ContainerTable>

                                        {editingIndex === index && (
                                            <EditContainer>
                                                <div className="modal-content">
                                                    <h3>Editando Aula</h3>
                                                    <ReactQuill
                                                        theme="snow"
                                                        modules={QUILL_MODULES}
                                                        value={editedDescription}
                                                        onChange={setEditedDescription}
                                                        placeholder="Descrição da aula"
                                                    />
                                                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                                                    <div className="BoxBtt">
                                                        <ButtonEdit
                                                            onClick={() => setEditingIndex(null)}
                                                            disabled={savingEdit}
                                                            style={{ background: '#f1f3f5', color: '#5b6b72' }}
                                                        >
                                                            Cancelar
                                                        </ButtonEdit>
                                                        <ButtonEdit onClick={handleSaveEdit} disabled={savingEdit}>
                                                            {savingEdit ? 'Salvando...' : 'Salvar'}
                                                        </ButtonEdit>
                                                    </div>
                                                </div>
                                            </EditContainer>
                                        )}
                                    </React.Fragment>
                                )
                            })}

                            {hasMore && !printing && (
                                <ShowMoreButton onClick={() => setShowAllClasses(prev => !prev)}>
                                    {showAllClasses
                                        ? 'Ver menos'
                                        : `Ver mais (${sortedDone.length - COLLAPSED_LIMIT})`}
                                </ShowMoreButton>
                            )}
                            </>
                        )}

                        {/* ── Dias letivos sem aula registrada ───────── */}
                        <AvisoDiasDaGrade grade={grade} />
                        <SectionTitle $tone="pending" style={{ marginTop: '8px' }}>
                            <h3>📌 Dias letivos sem aula registrada</h3>
                            <CountBadge $tone="pending">{filteredPending.length} pendentes</CountBadge>
                        </SectionTitle>

                        {filteredPending.length > 0 ? (
                            filteredPending.map((dia, index) => (
                                <ContainerTable key={index} $pending>
                                    <TableRow>
                                        <DateCell>📅 {dia} <span style={{ fontWeight: 600, color: '#5b6b72' }}>· {diaDaSemana(dia)}</span></DateCell>
                                        <DescriptionCell>
                                            <div style={{
                                                display: 'flex', justifyContent: 'space-between',
                                                alignItems: 'center', gap: '12px', flexWrap: 'wrap'
                                            }}>
                                                <span style={{ color: '#5b6b72', fontSize: '14px' }}>
                                                    Nenhuma aula registrada neste dia
                                                </span>
                                                <Button onClick={() => registrarAula(dia)} className={HiddenOnPrint}>
                                                    Registrar Aula
                                                </Button>
                                            </div>
                                        </DescriptionCell>
                                    </TableRow>
                                </ContainerTable>
                            ))
                        ) : (
                            <InfoText>Nenhum dia letivo pendente.</InfoText>
                        )}
                    </Table>

                    <ToGoBack className={HiddenOnPrint} onClick={goBack} role="button" tabIndex={0}>
                        <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                        <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                    </ToGoBack>
                </StudentSection>
            </ContainerDivs>
        </Container>
    )
}

export default Grade